"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6318],{

/***/ 20539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71577);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: inherit;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: none;\n    border: none;\n    box-shadow: none;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: unset;\n    color: ",
        ";\n    cursor: not-allowed;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n      :hover {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      :hover {\n        transition: 0.2s ease-in;\n        cursor: pointer;\n        background-color: ",
        ";\n        color: ",
        ";\n        border: 1px solid ",
        ";\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "ProximaNovaRg";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: ',
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  font-size: ",
        ";\n\n  ",
        "\n  ",
        ";\n\n  :focus,\n  :hover {\n    ",
        "\n  }\n\n  [disabled] {\n    color: ",
        " !important;\n    background-color: ",
        " !important;\n  }\n\n  ::after {\n    content: unset;\n  }\n\n  ",
        "\n\n  ",
        "\n\n    ::after {\n    content: unset;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




var buttonTheme = {
    primary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary),
    secondary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    facebook: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    trading: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    default: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject5(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro),
    borderless: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject6()),
    muted: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject7(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].suvaGrey */ .Z.suvaGrey, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light)
};
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        type: props.type || "default",
        margin: props.margin || "unset",
        height: props.height || "auto",
        radius: props.radius || "2px",
        isHoverable: props.isHoverable || false,
        width: props.width,
        fontSize: props.fontSize || "14px"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-b792a68c-0"
})(_templateObject11(), function(param) {
    var radius = param.radius;
    return radius;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize;
}, function(param) {
    var key = param.color;
    return _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject8(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit", _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit");
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].midgray */ .Z.midgray, function(param) {
    var isHoverable = param.isHoverable;
    return isHoverable && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject9(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro);
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject10(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 37949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  background: url(",
        ") center center/ ",
        " auto no-repeat;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = (styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        icon: props.icon || "",
        iconSize: props.iconSize || "12px",
        padding: props.padding || "unset",
        width: props.width || "12px",
        height: props.height || "12px",
        margin: props.margin || "unset"
    };
}).withConfig({
    componentId: "sc-8b5a1fc1-0"
})(_templateObject(), function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var iconSize = param.iconSize;
    return iconSize;
}, function(param) {
    var iconSize = param.iconSize;
    return iconSize;
}, function(param) {
    var icon = param.icon;
    return icon;
}, function(param) {
    var iconSize = param.iconSize;
    return iconSize;
}));


/***/ }),

/***/ 50864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67555);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_phone_input_2__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border: none;\n  outline: 0 !important;\n\n  .selected-flag {\n    height: 35px;\n    border: 1px solid ",
        ";\n    outline: 0;\n  }\n\n  > .react-tel-input.country-list {\n    list-style: none;\n    position: absolute !important;\n    z-index: 500 !important;\n    padding: 0;\n    margin: -1px 0 0 -1px;\n    background-color: ",
        ';\n    width: 310px;\n    max-height: 200px;\n    overflow-y: scroll;\n    border-radius: 0 0 3px 3px;\n    top: 34px;\n  }\n\n  input[type="tel"] {\n    outline: 0;\n    line-height: 35px;\n    height: 35px;\n    font-weight: 300;\n    width: 100%;\n    border: none;\n    font-size: 20px;\n    position: relative;\n    border-bottom: 1px solid ',
        ';\n    box-shadow: none;\n    border-radius: 0;\n  }\n\n  input[type="tel"]:focus,\n  input[type="text"]:focus {\n    border-color: ',
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var TelephoneInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)((react_phone_input_2__WEBPACK_IMPORTED_MODULE_1___default())).withConfig({
    componentId: "sc-dcb2dc87-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary);
/* harmony default export */ __webpack_exports__["Z"] = (TelephoneInput);


/***/ }),

/***/ 94970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61876);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68697);
/* harmony import */ var lib_api_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6242);
/* harmony import */ var features_register_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28456);



// API

// Constants

// Actions
var CONTEXT = "@register/registerForm";
var actionType = {
    VALIDATE_FIELD: "".concat(CONTEXT, "/VALIDATE_FIELD")
};
// Initial state
var initialState = {
    validations: {
        fullname: features_register_constants__WEBPACK_IMPORTED_MODULE_2__/* .validationReqSchema */ .wx,
        email: features_register_constants__WEBPACK_IMPORTED_MODULE_2__/* .validationReqSchema */ .wx,
        username: features_register_constants__WEBPACK_IMPORTED_MODULE_2__/* .validationReqSchema */ .wx,
        password: features_register_constants__WEBPACK_IMPORTED_MODULE_2__/* .validationReqSchema */ .wx
    }
};
// Reducers (define how the state changes)
var reducers = {
    storeFieldValidation: function(state, action) {
        var ref, ref1;
        var field = action.payload.field;
        var ref2;
        state.validations[field].error = (ref2 = (ref = action.payload) === null || ref === void 0 ? void 0 : ref.error) !== null && ref2 !== void 0 ? ref2 : null;
        state.validations[field].isChecked = true;
        state.validations[field].isLoading = false;
        var ref3;
        state.validations[field].message = (ref3 = (ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.message) !== null && ref3 !== void 0 ? ref3 : null;
    },
    resetFieldValidation: function(state, action) {
        var field = action.payload.field;
        state.validations[field].error = null;
        state.validations[field].isChecked = false;
        state.validations[field].isLoading = false;
        state.validations[field].message = null;
    },
    resetAllValidations: function() {
        return initialState;
    }
};
// Effects (thunks / async operations that needs side effects)
var effects = {
    // field validation
    validateField: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.VALIDATE_FIELD, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var field, value, tempKey, ref, message, ref1;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        field = param.field, value = param.value, tempKey = param.tempKey;
                        _ctx.prev = 1;
                        if (!(!field || !value)) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error("The ".concat(field, " field is required"));
                    case 4:
                        if (!(field === "password" && value.length < 6)) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Password harus terdiri dari minimal 6 karakter");
                    case 6:
                        if (!(field === "password" && value.length > 18)) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Password harus terdiri dari maksimal 18 karakter");
                    case 8:
                        _ctx.next = 10;
                        return lib_api_auth__WEBPACK_IMPORTED_MODULE_1__/* ["default"].validateRegisterForm */ .Z.validateRegisterForm(field, value, tempKey);
                    case 10:
                        ref = _ctx.sent;
                        message = ref.data;
                        return _ctx.abrupt("return", {
                            message: message
                        });
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        return _ctx.abrupt("return", Promise.reject((_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.cause) === null || ref1 === void 0 ? void 0 : ref1.message) || _ctx.t0.message));
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    15
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Selectors (getters)
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)(function(state) {
    return {
        validations: state.register.emailRegister.validations
    };
}, function(email) {
    return email;
});
// Extra reducers (handle actions that are not defined in this slice)
var extraReducers = function(builder) {
    builder.addCase(effects.validateField.pending, function(draft, action) {
        var _arg = action.meta.arg, field = _arg.field, value = _arg.value;
        if (!draft.validations[field].error) {
            draft.validations[field].data = value;
            draft.validations[field].isChecked = false;
        }
        draft.validations[field].isLoading = true;
    }).addCase(effects.validateField.fulfilled, function(draft, action) {
        var message = action.payload.message;
        var field = action.meta.arg.field;
        draft.validations[field].error = null;
        draft.validations[field].isChecked = true;
        draft.validations[field].isLoading = false;
        draft.validations[field].message = message;
    }).addCase(effects.validateField.rejected, function(draft, action) {
        var message = action.error.message, _meta = action.meta, field = _meta.arg.field;
        draft.validations[field].error = message;
        draft.validations[field].isChecked = true;
        draft.validations[field].isLoading = false;
        draft.validations[field].message = null;
    });
};
var emailRegisterSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    name: "emailRegister",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (emailRegisterSlice);


/***/ }),

/***/ 91950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ register; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/constants/localstorage.js
var localstorage = __webpack_require__(44252);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./src/global/AuthCardLayout/index.tsx + 1 modules
var AuthCardLayout = __webpack_require__(33406);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/hooks/useForm.js
var useForm = __webpack_require__(15077);
// EXTERNAL MODULE: ./src/utils/clevertap.js
var clevertap = __webpack_require__(48028);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/features/register/styled.ts
var styled = __webpack_require__(89213);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 1 modules
var tooltip = __webpack_require__(56266);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
;// CONCATENATED MODULE: ./src/features/register/InputForm/FormTooltip.tsx







function FormTooltip(param) {
    var children = param.children, title = param.title, description = param.description;
    var tooltipTitle = function() {
        if (title && description) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                direction: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "18px",
                        color: color/* default.highempahis */.Z.highempahis,
                        mb: "10px",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: color/* default.dimgray */.Z.dimgray,
                        children: description
                    })
                ]
            });
        }
        return null;
    };
    var additionalProps = !title && !description ? {
        visible: false
    } : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        trigger: [
            "focus"
        ],
        title: tooltipTitle,
        placement: "leftTop",
        color: "white",
        overlayInnerStyle: {
            color: "black",
            padding: "15px",
            width: "220px"
        }
    }, additionalProps), {
        children: children
    }));
}
/* harmony default export */ var InputForm_FormTooltip = (FormTooltip);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/InputForm.js
var InputForm = __webpack_require__(23906);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/register/InputForm/styled.ts
/* eslint-disable import/prefer-default-export */ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      span > div {\n        margin-bottom: -10px;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  button.btn-toggle {\n    background: transparent;\n    border: none;\n    position: absolute;\n    right: 0;\n    top: 0;\n    cursor: pointer;\n    z-index: 1;\n  }\n\n  button.btn-toggle img {\n    width: 16px;\n    height: 16px;\n\n    margin-top: 6px;\n  }\n\n  input:disabled {\n    background-color: ",
        " !important;\n    color: #858585;\n  }\n\n  input:disabled + div {\n    height: 0;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: calc(100% - 30px) !important;\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        color: ",
        ";\n      "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 36px;\n\n  label {\n    font-size: 14px;\n  }\n\n  input {\n    &::placeholder {\n      font-family: 'ProximaNovaLt';\n    }\n    font-size: 18px;\n    color: ",
        ";\n    width: 100% !important;\n    font-family: 'ProximaNovaLt';\n\n    ",
        "\n  }\n\n  input ~ label {\n    font-size: 14px;\n  }\n\n  input:not(:placeholder-shown) ~ label {\n    color: ",
        ";\n  }\n\n  input:focus ~ label {\n    color: ",
        ";\n  }\n\n  input:not(:placeholder-shown) ~ label,\n  input:focus ~ label {\n    font-family: 'ProximaNovaBd';\n    font-size: 12px !important;\n    top: -24px !important;\n\n    ",
        "\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 8px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var InputFormWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8ac88088-0"
})(_templateObject1(), color/* default.light */.Z.light, function(param) {
    var disabled = param.disabled;
    return disabled && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
});
var InputContainer = (0,styled_components_browser_esm/* default */.ZP)(InputForm/* default */.Z).attrs({
    p: "0"
}).withConfig({
    componentId: "sc-8ac88088-1"
})(_templateObject4(), color/* default.highempahis */.Z.highempahis, function(param) {
    var isPassword = param.isPassword;
    return isPassword && (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
}, color/* default.highempahis */.Z.highempahis, color/* default.primary */.Z.primary, function(param) {
    var error = param.error;
    return error && (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), color/* default.sunsetOrange */.Z.sunsetOrange);
});
var TextWarningContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8ac88088-2"
})(_templateObject5());

;// CONCATENATED MODULE: ./src/features/register/InputForm/index.tsx











var defaultHint = {
    title: "",
    description: ""
};
function InputForm_InputForm(_param) {
    var isChecked = _param.isChecked, errorMsg = _param.errorMsg, placeholder = _param.placeholder, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, type = _param.type, _hint = _param.hint, hint = _hint === void 0 ? defaultHint : _hint, _toggleButton = _param.toggleButton, toggleButton = _toggleButton === void 0 ? null : _toggleButton, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "isChecked",
        "errorMsg",
        "placeholder",
        "disabled",
        "type",
        "hint",
        "toggleButton"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputFormWrapper, {
        disabled: disabled,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputForm_FormTooltip, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hint), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputContainer, {
                    mt: "25px",
                    pr: "40px",
                    activeColorBar: errorMsg ? color/* default.sunsetOrange */.Z.sunsetOrange : color/* default.primary */.Z.primary,
                    error: errorMsg,
                    isPassword: !!toggleButton,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Input */.II, (0,_object_spread/* default */.Z)({
                        required: true,
                        placeholder: placeholder,
                        disabled: disabled,
                        type: type
                    }, otherProps))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: toggleButton,
                    children: toggleButton
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: errorMsg && isChecked,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextWarningContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/icon/register/input-warning.svg",
                                height: "18px",
                                width: "18px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                size: "12px",
                                color: color/* default.sunsetOrange */.Z.sunsetOrange,
                                "data-cy": "register-error-message",
                                children: errorMsg
                            })
                        ]
                    })
                })
            ]
        }))
    });
}
/* harmony default export */ var register_InputForm = (InputForm_InputForm);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/features/register/hooks.ts




var usePasswordVisibility = function() {
    var ref = (0,react.useState)({}), inputVisibility = ref[0], setInputVisibility = ref[1];
    var toggleVisibility = function(inputName) {
        setInputVisibility(function(prevVisibility) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevVisibility), (0,_define_property/* default */.Z)({}, inputName, !prevVisibility[inputName]));
        });
    };
    var getInputType = function(inputName) {
        return inputVisibility[inputName] ? "text" : "password";
    };
    return {
        getInputType: getInputType,
        toggleVisibility: toggleVisibility
    };
};

// EXTERNAL MODULE: ./src/features/register/EmailRegister/slice.ts
var slice = __webpack_require__(94970);
// EXTERNAL MODULE: ./src/features/register/slice.ts
var register_slice = __webpack_require__(7952);
// EXTERNAL MODULE: ./src/features/register/utils.ts
var utils = __webpack_require__(7865);
// EXTERNAL MODULE: ./src/features/register/constants.ts
var constants = __webpack_require__(28456);
;// CONCATENATED MODULE: ./src/features/register/EmailRegister/index.tsx





















function EmailRegister(param) {
    var onRegister = param.onRegister;
    var dispatch = (0,es/* useDispatch */.I0)();
    var validations = (0,es/* useSelector */.v9)(slice/* selectors */.wl).validations;
    var ref = (0,es/* useSelector */.v9)(register_slice/* selectors */.wl), initialEmail = ref.email, emailStatus = ref.emailStatus, error = ref.error, initialFullname = ref.fullname, tempKey = ref.tempKey, type = ref.type, initialUsername = ref.username;
    var isSocialMediaForm = type !== constants/* registerTypes.EMAIL */.E8.EMAIL;
    var isFacebookWithoutEmail = type === constants/* registerTypes.FACEBOOK */.E8.FACEBOOK && !initialEmail;
    var isEmailNotVerified = emailStatus === constants/* emailStatuses.NOT_VERIFIED */.cs.NOT_VERIFIED;
    var canChangeEmail = !isSocialMediaForm || isFacebookWithoutEmail || isEmailNotVerified;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useForm/* default */.Z)({
        initialState: initialFullname
    }), 2), fullname = ref1[0], setFullname = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useForm/* default */.Z)({
        initialState: initialEmail
    }), 2), email = ref2[0], setEmail = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useForm/* default */.Z)({
        initialState: initialUsername
    }), 2), username = ref3[0], setUsername = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useForm/* default */.Z)({
        initialState: ""
    }), 2), password = ref4[0], setPassword = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useForm/* default */.Z)({
        initialState: ""
    }), 2), passwordConf = ref5[0], setPasswordConf = ref5[1];
    var ref6 = (0,react.useState)(null), passwordConfError = ref6[0], setPasswordConfError = ref6[1];
    var ref7 = (0,react.useState)(false), isPasswordConfChecked = ref7[0], setPasswordConfChecked = ref7[1];
    var ref8 = (0,react.useState)(""), verificationToken = ref8[0], setVerificationToken = ref8[1];
    var ref9 = (0,react.useState)(0), reCaptchaID = ref9[0], setRecaptchaId = ref9[1];
    var ref10 = usePasswordVisibility(), getInputType = ref10.getInputType, toggleVisibility = ref10.toggleVisibility;
    var validateValues = function() {
        var fields = [
            fullname,
            email,
            username
        ];
        var isPasswordFilled = isSocialMediaForm || password && passwordConf;
        var isInputFilled = fields.every(function(item) {
            return item.trim().length > 0;
        });
        var isInputNoError = Object.values(validations).every(function(item) {
            return !item.error;
        });
        var isInputValid = isInputNoError && !passwordConfError;
        return isInputFilled && isInputValid && isPasswordFilled;
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var isInputValid;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        isInputValid = validateValues();
                        if (isInputValid) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        (0,clevertap/* clevertapEvent */.Lq)("Login Selected", {
                            "Login Method": constants/* registerTypes.EMAIL */.E8.EMAIL
                        });
                        if (!(error === constants/* errorMessage.SOCIAL_EMAIL_REGISTERED */.N3.SOCIAL_EMAIL_REGISTERED)) {
                            _ctx.next = 8;
                            break;
                        }
                        (0,utils/* handleRegistrationError */.zj)(constants/* errorMessage.SOCIAL_EMAIL_REGISTERED */.N3.SOCIAL_EMAIL_REGISTERED, email);
                        return _ctx.abrupt("return");
                    case 8:
                        if (canChangeEmail) {
                            _ctx.next = 11;
                            break;
                        }
                        dispatch(register_slice/* default.actions.changeForm */.ZP.actions.changeForm({
                            target: constants/* formTypes.PHONE */.o_.PHONE
                        }));
                        return _ctx.abrupt("return");
                    case 11:
                        _ctx.prev = 11;
                        _ctx.next = 14;
                        return onRegister({
                            fullname: fullname,
                            email: email,
                            username: username,
                            password: password,
                            passwordConf: passwordConf,
                            verificationToken: verificationToken
                        });
                    case 14:
                        _ctx.next = 19;
                        break;
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](11);
                        // Reset reCaptchaId to re-call GoogleReCaptcha.onVerify
                        setRecaptchaId(Date.now());
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    11,
                    16
                ]
            ]);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var debouncedPassword = lodash_debounce_default()(function() {
        var errorConf = (0,utils/* validatePasswordConf */.Kq)(password, passwordConf);
        setPasswordConfError(errorConf);
        setPasswordConfChecked(true);
    }, 500);
    (0,react.useEffect)(function() {
        if (passwordConf) {
            debouncedPassword(); // Debounced password validation
        }
        return function() {
            debouncedPassword.cancel();
        };
    }, [
        password,
        passwordConf
    ]);
    (0,react.useEffect)(function() {
        setRecaptchaId(Date.now());
        if (!tempKey) return;
        var fieldsToValidate = [
            {
                field: "fullname",
                value: fullname
            },
            {
                field: "username",
                value: username
            }, 
        ];
        fieldsToValidate.forEach(function(param) {
            var field = param.field, value = param.value;
            if (value && field) {
                dispatch(slice/* effects.validateField */.Sz.validateField({
                    field: field,
                    value: value,
                    tempKey: tempKey
                }));
            }
        });
    }, []);
    var handleChangeEmail = function(e) {
        if (!canChangeEmail) return;
        setEmail(e);
        // Validate email
        var value = e.target.value;
        var validation = (0,utils/* validateEmail */.oH)(value);
        dispatch(slice/* default.actions.storeFieldValidation */.ZP.actions.storeFieldValidation(validation));
    };
    var debounceValidations = lodash_debounce_default()(function(param) {
        var name = param.name, value = param.value;
        if (!tempKey) return;
        dispatch(slice/* effects.validateField */.Sz.validateField({
            field: name,
            value: value,
            tempKey: tempKey
        }));
    }, 500);
    var handleFormBlur = (0,react.useCallback)(function(e) {
        var _target = e.target, name = _target.name, value = _target.value;
        dispatch(slice/* default.actions.resetFieldValidation */.ZP.actions.resetFieldValidation({
            field: name
        }));
        if (isSocialMediaForm) {
            debounceValidations({
                name: name,
                value: value
            });
        }
    }, []);
    var generateReCaptchaToken = (0,react.useCallback)(function(token) {
        return setVerificationToken(token);
    }, [
        reCaptchaID
    ]);
    var renderToggleButton = function(inputName) {
        var isShown = getInputType(inputName) === "text";
        var iconSrc = isShown ? "/icon/register/icon-hide.svg" : "/icon/register/icon-show.svg";
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            tabIndex: -1,
            onClick: function() {
                return toggleVisibility(inputName);
            },
            type: "button",
            className: "btn-toggle",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: iconSrc
            })
        });
    };
    var isValidForm = validateValues();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthCardLayout/* default */.Z, {
        withLoginLink: true,
        withTermsLink: true,
        wrapperClassName: "register",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_google_recaptcha_v3_esm/* GoogleReCaptcha */.mP, {
                onVerify: generateReCaptchaToken,
                action: "check_register_web"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(register_InputForm, {
                        errorMsg: validations.fullname.error,
                        isChecked: validations.fullname.isChecked,
                        name: "fullname",
                        onChange: function(e) {
                            setFullname(e);
                            handleFormBlur(e);
                        },
                        placeholder: "Your Name",
                        type: "textbox",
                        value: fullname,
                        hint: constants/* hints.NAME */.eP.NAME,
                        required: true,
                        id: "fullname"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(register_InputForm, {
                        errorMsg: validations.email.error,
                        isChecked: validations.email.isChecked,
                        name: "email",
                        onChange: handleChangeEmail,
                        placeholder: "Your Email",
                        type: "textbox",
                        value: email,
                        disabled: !canChangeEmail,
                        hint: constants/* hints.EMAIL */.eP.EMAIL,
                        required: true,
                        id: "email"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(register_InputForm, {
                        errorMsg: validations.username.error,
                        name: "username",
                        isChecked: validations.username.isChecked,
                        onChange: function(e) {
                            setUsername(e);
                            handleFormBlur(e);
                        },
                        placeholder: "Username",
                        type: "textbox",
                        value: username,
                        hint: constants/* hints.USERNAME */.eP.USERNAME,
                        required: true,
                        id: "username"
                    }),
                    !isSocialMediaForm && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(register_InputForm, {
                                errorMsg: validations.password.error,
                                isChecked: validations.password.isChecked,
                                name: "password",
                                onChange: function(e) {
                                    setPassword(e);
                                    handleFormBlur(e);
                                },
                                placeholder: "Password",
                                type: getInputType("password"),
                                value: password,
                                hint: constants/* hints.PASSWORD */.eP.PASSWORD,
                                required: true,
                                id: "password",
                                toggleButton: renderToggleButton("password"),
                                autoComplete: "new-password"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(register_InputForm, {
                                onChange: setPasswordConf,
                                placeholder: "Confirm Password",
                                type: getInputType("confirmation"),
                                value: passwordConf,
                                errorMsg: passwordConfError,
                                isChecked: isPasswordConfChecked,
                                required: true,
                                id: "confirm-password",
                                toggleButton: renderToggleButton("confirmation"),
                                autoComplete: "new-password"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        // @ts-expect-error
                        onClick: handleSubmit,
                        htmlType: "submit",
                        type: "primary",
                        mt: "48px",
                        height: "44px",
                        block: true,
                        disabled: !isValidForm,
                        id: "register-button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            family: "bold",
                            color: color/* default.light */.Z.light,
                            children: "Register"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var register_EmailRegister = (EmailRegister);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
;// CONCATENATED MODULE: ./src/features/register/NotifyVerification/index.tsx







function NotifyVerification(param) {
    var onContinue = param.onContinue, recipient = param.recipient, type = param.type;
    var isPhone = type === "phone";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthCardLayout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "center",
                align: "center",
                pt: "40px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "20px",
                        family: "light",
                        pr: "5px",
                        children: isPhone ? "Check Your Phone Message" : "Check Your Email Message"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                            className: "icon-toolbar_valid",
                            size: "24px",
                            color: color/* default.primary */.Z.primary
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                align: "center",
                pt: "20px",
                color: color/* default.dimgray */.Z.dimgray,
                children: isPhone ? "A verification code has been sent to your phone: ".concat(recipient) : "A verification code has been sent to your email: ".concat(recipient)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justify: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    onClick: onContinue,
                    type: "primary",
                    // @ts-expect-error
                    mt: "20px",
                    height: "35px",
                    round: true,
                    block: true,
                    id: "verify-phone",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "light",
                        size: "16px",
                        family: "light",
                        children: isPhone ? "Verify Phone Number" : "Verify Email"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var register_NotifyVerification = (NotifyVerification);

;// CONCATENATED MODULE: ./src/features/register/PhoneError/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 120px;\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 16px;\n  text-align: center;\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  margin: 0;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 32px;\n  color: #000000;\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  line-height: 135%;\n  color: #969696;\n"
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e6590818-0"
})(styled_templateObject());
var ImageWrapper = (0,styled_components_browser_esm/* default */.ZP)(Wrapper).withConfig({
    componentId: "sc-e6590818-1"
})(styled_templateObject1());
var TextWrapper = (0,styled_components_browser_esm/* default */.ZP)(Wrapper).withConfig({
    componentId: "sc-e6590818-2"
})(styled_templateObject2());
var Title = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-e6590818-3"
})(styled_templateObject3());
var Description = (0,styled_components_browser_esm/* default */.ZP)(Title).withConfig({
    componentId: "sc-e6590818-4"
})(styled_templateObject4());


;// CONCATENATED MODULE: ./src/features/register/PhoneError/index.tsx







function PhoneError(param) {
    var onBackLogin = param.onBackLogin, onBackChangePhone = param.onBackChangePhone;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthCardLayout/* default */.Z, {
        withLogo: false,
        wrapperClassName: "register",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/illustration/phone-registered.svg",
                    alt: "Phone Error"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: "Nomor HP Sudah Terdaftar di Stockbit"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        children: "Silahkan login atau gunakan nomor lain untuk pendaftaran baru."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                id: "back-login-button",
                type: "primary",
                height: "44px",
                block: true,
                onClick: onBackLogin,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    family: "bold",
                    color: color/* default.light */.Z.light,
                    children: "Login"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                id: "back-change-phone",
                type: "default",
                height: "44px",
                block: true,
                onClick: onBackChangePhone,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    family: "bold",
                    color: color/* default.primary */.Z.primary,
                    children: "Gunakan Nomor HP Lain"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/@deprecated-ui/common/TelephoneInput.js
var TelephoneInput = __webpack_require__(50864);
;// CONCATENATED MODULE: ./src/features/register/PhoneRegister/index.tsx












function PhoneRegister(param) {
    var onRegister = param.onRegister;
    var ref = (0,react.useState)({
        countryCode: "",
        dialCode: "",
        format: "",
        name: "",
        phoneNumber: ""
    }), phone = ref[0], setPhoneNumber = ref[1];
    var handleSendClick = function() {
        onRegister(phone.phoneNumber, phone.dialCode);
    };
    var handlePhoneInputChange = function(phoneNumber, countryInfo) {
        setPhoneNumber((0,_object_spread/* default */.Z)({
            phoneNumber: phoneNumber
        }, countryInfo));
    };
    var handleResetPhoneNumber = function() {
        setPhoneNumber(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                phoneNumber: phone.dialCode
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthCardLayout/* default */.Z, {
        wrapperClassName: "register",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                size: "24px",
                align: "center",
                weight: "700",
                color: color/* default.highempahis */.Z.highempahis,
                children: "Phone Verification"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                size: "16px",
                family: "light",
                color: color/* default.highgray */.Z.highgray,
                style: {
                    lineHeight: "135%"
                },
                children: [
                    "We will send you a confirmation code. Input your phone number eg.",
                    " ",
                    "+6287654321000"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "12px",
                        family: "bold",
                        pb: "10px",
                        children: "Nomor HP"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* InputPhoneContainer */.Pk, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TelephoneInput/* default */.Z, {
                                // @ts-expect-error
                                id: "phone-input",
                                value: phone.phoneNumber,
                                country: "id",
                                placeholder: "+62 876-5432-1000",
                                onChange: handlePhoneInputChange,
                                buttonClass: "phone-dropdown-button",
                                inputClass: "phone-input",
                                autoFormat: true,
                                enableLongNumbers: 15,
                                defaultMask: "...-....-...."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: phone === null || phone === void 0 ? void 0 : phone.phoneNumber,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: handleResetPhoneNumber,
                                    type: "button",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/icon/close-fill.svg",
                                        alt: ""
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                id: "send-code",
                type: "primary",
                height: "44px",
                block: true,
                onClick: handleSendClick,
                disabled: !phone.phoneNumber.slice(phone.dialCode.length),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    family: "bold",
                    color: color/* default.light */.Z.light,
                    children: "Send Verification Code"
                })
            })
        ]
    });
}
/* harmony default export */ var register_PhoneRegister = (PhoneRegister);

// EXTERNAL MODULE: ./src/global/AuthCardLayout/Divider.tsx
var Divider = __webpack_require__(27253);
// EXTERNAL MODULE: ./src/features/register/GoogleOauth/index.tsx
var GoogleOauth = __webpack_require__(79106);
// EXTERNAL MODULE: ./src/features/register/FacebookOauth/index.tsx
var FacebookOauth = __webpack_require__(72099);
;// CONCATENATED MODULE: ./src/features/register/Selection/index.tsx









function Selection(param) {
    var handleOnMount = param.handleOnMount, handleNavigate = param.handleNavigate;
    (0,react.useEffect)(function() {
        if (handleOnMount) handleOnMount();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthCardLayout/* default */.Z, {
        withLoginLink: true,
        withTermsLink: true,
        wrapperClassName: "register",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleOauth/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookOauth/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                label: "Or",
                className: "form-divider"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                id: "email-register",
                type: "primary",
                onClick: handleNavigate,
                height: "44px",
                block: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: color/* default.light */.Z.light,
                    size: "14px",
                    family: "bold",
                    children: "Register with Email"
                })
            })
        ]
    });
}
/* harmony default export */ var register_Selection = (Selection);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/assets/base64icon/index.js
var base64icon = __webpack_require__(54392);
;// CONCATENATED MODULE: ./src/features/register/SuccessfulRegistration/index.tsx










function SuccessfulRegistration() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthCardLayout/* default */.Z, {
        withLogo: false,
        wrapperClassName: "register",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justify: "center",
                align: "center",
                mt: "20px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    style: {
                        width: 80
                    },
                    src: base64icon/* successRegisterIcon */.vq
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "center",
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "20px",
                        family: "bold",
                        pr: "5px",
                        children: "Registration Successful"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                            className: "icon-toolbar_valid",
                            size: "24px",
                            color: color/* default.primary */.Z.primary
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: color/* default.highgray */.Z.highgray,
                style: {
                    lineHeight: 1.5
                },
                align: "center",
                children: "We have sent you an email to create your password should you wish to login using your username/email"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/stream",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    type: "primary",
                    mx: "auto",
                    mb: "20px",
                    height: "44px",
                    block: true,
                    as: "a",
                    style: {
                        width: "fit-content",
                        paddingLeft: 30,
                        paddingRight: 30
                    },
                    className: "btn-successful-register",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        family: "bold",
                        color: color/* default.light */.Z.light,
                        children: "Ok"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var register_SuccessfulRegistration = (SuccessfulRegistration);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
;// CONCATENATED MODULE: ./src/features/register/InputTokenV2/index.tsx




function PinInput(param) {
    var _length = param.length, length = _length === void 0 ? 4 : _length, onVerify = param.onVerify;
    var ref = (0,react.useState)([]), code = ref[0], setCode = ref[1];
    var inputRefs = (0,react.useRef)(Array(length).fill(null));
    (0,react.useEffect)(function() {
        var ref;
        (ref = inputRefs.current[0]) === null || ref === void 0 ? void 0 : ref.focus();
    }, []);
    (0,react.useEffect)(function() {
        var enteredCode = code.join("");
        onVerify(enteredCode);
    }, [
        code,
        onVerify
    ]);
    var handleChange = function(index, value) {
        var isNumeric = /^\d*$/.test(value);
        if (isNumeric) {
            var newCode = (0,_to_consumable_array/* default */.Z)(code);
            newCode[index] = value;
            setCode(newCode);
            var input = inputRefs.current[index];
            if (input && value && index < length - 1) {
                setTimeout(function() {
                    var ref;
                    (ref = inputRefs.current[index + 1]) === null || ref === void 0 ? void 0 : ref.focus();
                }, 0);
            }
            var inputValueLength = (input === null || input === void 0 ? void 0 : input.value.length) || 0;
            input === null || input === void 0 ? void 0 : input.setSelectionRange(inputValueLength, inputValueLength);
        }
    };
    var handleBackspace = function(index, event) {
        if (event.key === "Backspace" && !code[index] && index > 0) {
            var ref;
            (ref = inputRefs.current[index - 1]) === null || ref === void 0 ? void 0 : ref.focus();
            handleChange(index - 1, "");
        }
    };
    var handleVerify = function() {
        var isCodeFilled = code.length === length && code.every(function(value) {
            return value;
        });
        if (isCodeFilled) {
            var enteredCode = code.join("");
            onVerify(enteredCode);
        }
    };
    var handleKeyDown = function(event) {
        var currentIndex = inputRefs.current.findIndex(function(ref) {
            return ref === event.target;
        });
        if (event.key === "Enter" && code.length === length) {
            handleVerify();
        } else if (event.key === "ArrowLeft" && currentIndex > 0) {
            var ref;
            (ref = inputRefs.current[currentIndex - 1]) === null || ref === void 0 ? void 0 : ref.focus();
        } else if (event.key === "ArrowRight" && currentIndex < length - 1) {
            var ref1;
            (ref1 = inputRefs.current[currentIndex + 1]) === null || ref1 === void 0 ? void 0 : ref1.focus();
        }
    };
    var handleFocus = function(event) {
        var input = event.target;
        var inputValueLength = input.value.length;
        input.setSelectionRange(inputValueLength, inputValueLength);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* InputPinWrapper */.Tc, {
        "data-cy": "input-token-container",
        children: Array.from({
            length: length
        }, function(_, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                ref: function(ref) {
                    inputRefs.current[index] = ref;
                },
                type: "text",
                maxLength: 1,
                value: code[index] || "",
                onChange: function(e) {
                    return handleChange(index, e.target.value);
                },
                onKeyDown: function(e) {
                    return handleBackspace(index, e);
                },
                onKeyUp: handleKeyDown,
                onFocus: handleFocus,
                className: code[index] ? "filled" : "",
                "data-cy": "input-token"
            }, index);
        })
    });
}
/* harmony default export */ var InputTokenV2 = (PinInput);

// EXTERNAL MODULE: ./src/hooks/useCountdown.ts
var useCountdown = __webpack_require__(31151);
;// CONCATENATED MODULE: ./src/features/register/TimerOtp/index.tsx




var INITIAL_TIMER_SECOND = 60;
function TimerOtp(param) {
    var onResend = param.onResend;
    var ref = (0,useCountdown/* default */.Z)({
        onResend: onResend,
        time: INITIAL_TIMER_SECOND
    }), seconds = ref.seconds, minutes = ref.minutes, isFinished = ref.isFinished, onEnd = ref.onEnd;
    return(// @ts-expect-error
    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        align: "center",
        pt: "12px",
        children: isFinished ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            as: "a",
            size: "14px",
            onClick: onEnd,
            children: "Kirim Ulang"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
            size: "14px",
            align: "center",
            color: color/* default.highgray */.Z.highgray,
            children: [
                "Kirim Ulang (",
                minutes,
                ":",
                seconds,
                ")"
            ]
        })
    }));
}
/* harmony default export */ var register_TimerOtp = (TimerOtp);

;// CONCATENATED MODULE: ./src/features/register/VerifyEmail/index.tsx









function VerifyEmail(param) {
    var onVerify = param.onVerify, onChangeEmail = param.onChangeEmail, onResend = param.onResend, _email = param.email, email = _email === void 0 ? "" : _email;
    var ref = (0,react.useState)(""), emailTokenState = ref[0], setEmailTokenState = ref[1];
    var handleVerifyFilled = function(emailToken) {
        // save emailToken to state
        // for button click
        setEmailTokenState(emailToken);
    // Previously we auto call API when all input has been filled
    // But it also could produce an infinite loop, thus
    // we opt out that feature and make it so we call API when button is clicked
    };
    var handleOnclickBtnVerify = function() {
        // HIT API verify user
        onVerify(emailTokenState);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthCardLayout/* default */.Z, {
        wrapperClassName: "register",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                size: "24px",
                align: "center",
                color: color/* default.black */.Z.black,
                children: "Verification Code"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                size: "16px",
                family: "light",
                color: color/* default.highgray */.Z.highgray,
                style: {
                    lineHeight: "135%"
                },
                children: [
                    "A verification code has been sent to your email: (",
                    email,
                    ")"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* InputPinContainer */.KM, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputTokenV2, {
                        onVerify: handleVerifyFilled
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(register_TimerOtp, {
                        onResend: onResend
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                type: "primary",
                height: "44px",
                onClick: handleOnclickBtnVerify,
                block: true,
                disabled: (emailTokenState === null || emailTokenState === void 0 ? void 0 : emailTokenState.length) !== 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    family: "bold",
                    color: color/* default.light */.Z.light,
                    children: "Verify Email"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                align: "center",
                size: "12px",
                color: color/* default.black */.Z.black,
                children: [
                    "Didn't receive email?",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "a",
                        size: "12px",
                        onClick: onChangeEmail,
                        children: "Change Your Email"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var register_VerifyEmail = (VerifyEmail);

// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 4 modules
var credentials = __webpack_require__(21671);
// EXTERNAL MODULE: ./src/utils/textFormatter.ts
var textFormatter = __webpack_require__(23485);
;// CONCATENATED MODULE: ./src/features/register/VerifyPhone/index.tsx













function VerifyPhone(param) {
    var onVerify = param.onVerify, _autoRedirect = param.autoRedirect, autoRedirect = _autoRedirect === void 0 ? true : _autoRedirect, onResend = param.onResend, onChangePhone = param.onChangePhone, _phoneNumber = param.phoneNumber, phoneNumber = _phoneNumber === void 0 ? "" : _phoneNumber;
    var ref = (0,react.useState)(""), phoneTokenState = ref[0], setPhoneTokenState = ref[1];
    var router = (0,next_router.useRouter)();
    // request states
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    // Check Logged In
    (0,react.useEffect)(function() {
        if (isLoggedIn && autoRedirect) {
            router.push("/stream");
        }
    }, [
        isLoggedIn,
        autoRedirect,
        router
    ]);
    var handleVerifyClick = function(phoneToken) {
        // save phoneToken to state
        // for button click
        setPhoneTokenState(phoneToken);
    // Previously we auto call API when all input has been filled
    // But it also could produce an infinite loop, thus
    // we opt out that feature and make it so we call API when button is clicked
    };
    var handleOnclickBtnVerify = function() {
        // HIT API verify user
        onVerify(phoneTokenState);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthCardLayout/* default */.Z, {
        wrapperClassName: "register",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                size: "24px",
                align: "center",
                color: color/* default.highempahis */.Z.highempahis,
                weight: "bold",
                children: "Verification Code"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                size: "16px",
                color: color/* default.highgray */.Z.highgray,
                family: "light",
                style: {
                    lineHeight: "135%"
                },
                children: [
                    "Verification code has been sent to",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                        children: [
                            "+",
                            (0,textFormatter/* formatCensorPhoneNumber */.E)(phoneNumber)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* InputPinContainer */.KM, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputTokenV2, {
                        onVerify: handleVerifyClick
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(register_TimerOtp, {
                        onResend: onResend
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                id: "verify-otp",
                type: "primary",
                height: "44px",
                onClick: handleOnclickBtnVerify,
                block: true,
                disabled: (phoneTokenState === null || phoneTokenState === void 0 ? void 0 : phoneTokenState.length) !== 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    family: "bold",
                    color: color/* default.light */.Z.light,
                    children: "Verification"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        align: "center",
                        size: "12px",
                        color: color/* default.black */.Z.black,
                        children: "Didn't receive SMS ?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        align: "center",
                        size: "12px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            as: "a",
                            size: "12px",
                            onClick: onChangePhone,
                            children: "Change Phone Number"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var register_VerifyPhone = (VerifyPhone);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./src/global/Icons/ChatSvg.tsx
var ChatSvg = __webpack_require__(37662);
// EXTERNAL MODULE: ./src/global/Icons/WhatsAppSvg.tsx
var WhatsAppSvg = __webpack_require__(68749);
// EXTERNAL MODULE: ./src/global/OtpMethodList/index.tsx + 2 modules
var OtpMethodList = __webpack_require__(50226);
// EXTERNAL MODULE: ./src/typings/auth.ts
var auth = __webpack_require__(97718);
// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 14 modules
var es_form = __webpack_require__(98294);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
;// CONCATENATED MODULE: ./src/features/register/SendOTPMethod/styled.ts

function SendOTPMethod_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n"
    ]);
    SendOTPMethod_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SendOTPMethod_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.ant-btn.ant-btn-primary {\n    height: auto;\n    padding: 12.5px;\n    border-radius: 4px;\n\n    font-weight: bold;\n    font-size: 14px;\n    line-height: 19px;\n\n    :disabled {\n      color: #ffffff;\n    }\n  }\n"
    ]);
    SendOTPMethod_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var OTPMethodForm = (0,styled_components_browser_esm/* default */.ZP)(es_form/* default */.Z).withConfig({
    componentId: "sc-fd80c3f8-0"
})(SendOTPMethod_styled_templateObject());
var SendButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-fd80c3f8-1"
})(SendOTPMethod_styled_templateObject1());

;// CONCATENATED MODULE: ./src/features/register/SendOTPMethod/index.tsx











var SendOTPMethod = function(param) {
    var _title = param.title, title = _title === void 0 ? "Choose OTP Sending Method" : _title, _description = param.description, description = _description === void 0 ? [
        "Make sure the phone number ",
        " is correct before you send OTP", 
    ] : _description, _phone = param.phone, phone = _phone === void 0 ? "" : _phone, _onSubmit = param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit;
    var ref = (0,react.useState)(auth/* OtpChannel.WhatsApp */.z.WhatsApp), selectedMethod = ref[0], setSelectedMethod = ref[1];
    var handleMethodClick = function(value) {
        setSelectedMethod(value);
    };
    var handleSubmit = function() {
        onSubmit(selectedMethod);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthCardLayout/* default */.Z, {
        wrapperClassName: "register",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                weight: "700",
                size: "24px",
                height: "32px",
                align: "center",
                color: color/* default.highempahis */.Z.highempahis,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                size: "16px",
                height: "22px",
                color: "#858585",
                children: [
                    description[0],
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: phone.replace(/(\d{2})(\d{3})(\d{4})(\d{4})/, "+$1-$2-$3-$4")
                    }),
                    description[1]
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OtpMethodList/* default */.Z, {
                defaultMethod: selectedMethod,
                data: [
                    {
                        value: auth/* OtpChannel.WhatsApp */.z.WhatsApp,
                        title: "Send by WhatsApp",
                        description: "Free of charge",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            component: WhatsAppSvg/* default */.Z,
                            style: {
                                color: "#00AB6B"
                            }
                        })
                    },
                    {
                        value: auth/* OtpChannel.Sms */.z.Sms,
                        title: "Send by SMS",
                        description: "Service charges may apply",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            component: ChatSvg/* default */.Z,
                            style: {
                                color: "#00AB6B"
                            }
                        })
                    }, 
                ],
                onSelect: handleMethodClick
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SendButton, {
                type: "primary",
                onClick: handleSubmit,
                disabled: !selectedMethod,
                children: "Send Verification Code"
            })
        ]
    });
};
/* harmony default export */ var register_SendOTPMethod = (SendOTPMethod);

// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
;// CONCATENATED MODULE: ./src/features/register/OtpLimit/styled.ts

function OtpLimit_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 160px;\n  height: auto;\n"
    ]);
    OtpLimit_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OtpLimit_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.ant-btn.ant-btn-primary {\n    height: auto;\n    width: 100%;\n    padding: 12.5px;\n\n    font-weight: bold;\n    font-size: 14px;\n    line-height: 19px;\n  }\n"
    ]);
    OtpLimit_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var ModalIllustration = (0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z).withConfig({
    componentId: "sc-91e0d341-0"
})(OtpLimit_styled_templateObject());
var BackButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-91e0d341-1"
})(OtpLimit_styled_templateObject1());

;// CONCATENATED MODULE: ./src/features/register/OtpLimit/index.tsx





var OtpLimit = function(param) {
    var _title = param.title, title = _title === void 0 ? "Try Again After 1 Hour" : _title, _description = param.description, description = _description === void 0 ? "You have reached 5 times OTP sending limit." : _description, _buttonText = param.buttonText, buttonText = _buttonText === void 0 ? "Back" : _buttonText, _onBackClick = param.onBackClick, onBackClick = _onBackClick === void 0 ? function() {} : _onBackClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthCardLayout/* default */.Z, {
        wrapperClassName: "register",
        withLogo: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                justify: "center",
                gutter: [
                    0,
                    24
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                            align: "middle",
                            justify: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalIllustration, {
                                    src: "/images/phone-otp-timer.svg"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                            align: "middle",
                            justify: "center",
                            gutter: [
                                0,
                                16
                            ],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                    span: 24,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        align: "center",
                                        weight: "700",
                                        size: "24px",
                                        height: "32px",
                                        color: "#333333",
                                        children: title
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                    span: 24,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        align: "center",
                                        size: "16px",
                                        height: "22px",
                                        color: "#858585",
                                        children: description
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                    span: 24,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton, {
                        type: "primary",
                        onClick: onBackClick,
                        children: buttonText
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var register_OtpLimit = (OtpLimit);

;// CONCATENATED MODULE: ./src/features/register/index.tsx






















function Register() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var registerState = (0,es/* useSelector */.v9)(register_slice/* selectors */.wl);
    var currentForm = registerState.currentForm, email = registerState.email, phoneNumber = registerState.phoneNumber, type = registerState.type;
    (0,react.useEffect)(function() {
        if ((0,app/* isClient */.C5)()) {
            var storedData = localStorage.getItem(localstorage/* REGISTRATION_DATA */.BP);
            if (storedData) {
                var data = JSON.parse(storedData);
                var dateNow = moment_default()();
                var storedAt = moment_default()(data.storedAt);
                var diff = dateNow.diff(storedAt, "minutes");
                if (diff < 10) {
                    dispatch(register_slice/* default.actions.storeAllData */.ZP.actions.storeAllData(data));
                } else {
                    (0,utils/* removeData */.NU)();
                }
            }
        }
        return function() {
            dispatch(register_slice/* default.actions.changeForm */.ZP.actions.changeForm({
                target: constants/* formTypes.SELECTION */.o_.SELECTION
            }));
        };
    }, []);
    var handleChangeForm = function(targetForm) {
        dispatch(register_slice/* default.actions.changeForm */.ZP.actions.changeForm({
            target: targetForm
        }));
    };
    var handleRegisterUser = function(phone, code) {
        dispatch(register_slice/* default.actions.savePhoneNumber */.ZP.actions.savePhoneNumber({
            phoneNumber: phone,
            code: code
        }));
        handleChangeForm(constants/* formTypes.SEND_OTP_METHOD */.o_.SEND_OTP_METHOD);
    };
    var handleSendOTPSubmit = function(channel) {
        dispatch(register_slice/* effects.verifyPhone */.Sz.verifyPhone({
            code: registerState.code,
            phoneNumber: phoneNumber,
            channel: channel
        }));
    };
    var handleVerifyEmailRegistration = function(data) {
        return dispatch(register_slice/* effects.verifyRegistration */.Sz.verifyRegistration(data)).unwrap();
    };
    var handleContinueVerifyEmail = function() {
        handleChangeForm(constants/* formTypes.VERIFY_EMAIL */.o_.VERIFY_EMAIL);
    };
    var handleContinueVerifyPhone = function() {
        handleChangeForm(constants/* formTypes.VERIFY_PHONE */.o_.VERIFY_PHONE);
    };
    var handleVerifyEmail = function(code) {
        dispatch(register_slice/* effects.validateEmailOtp */.Sz.validateEmailOtp({
            code: code
        }));
    };
    var handleVerifyPhone = function(otp) {
        dispatch(register_slice/* effects.validatePhoneOtp */.Sz.validatePhoneOtp({
            otp: otp
        }));
    };
    var handleResendCodeEmail = function() {
        dispatch(register_slice/* effects.resendEmailOtp */.Sz.resendEmailOtp());
    };
    var handleResendCodePhone = function() {
        handleChangeForm(constants/* formTypes.SEND_OTP_METHOD */.o_.SEND_OTP_METHOD);
    };
    var handleChangeEmail = function() {
        handleChangeForm(constants/* formTypes.EMAIL */.o_.EMAIL);
    };
    var handleChangePhone = function() {
        handleChangeForm(constants/* formTypes.PHONE */.o_.PHONE);
    };
    var handleResetState = function() {
        dispatch(slice/* default.actions.resetAllValidations */.ZP.actions.resetAllValidations());
        dispatch(register_slice/* default.actions.resetAllData */.ZP.actions.resetAllData());
    };
    var handleBackToLogin = function() {
        if ((0,app/* isClient */.C5)()) localStorage.setItem(constants/* LS_PHONE_REGISTER */.b_, phoneNumber);
        router.push("/login");
        (0,utils/* removeData */.NU)();
    };
    var renderFormComponent = function(component) {
        var includeCustomStyle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* RegisterStyle */.BH, {}),
                includeCustomStyle && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* CustomStyle */.cW, {}),
                component
            ]
        });
    };
    switch(currentForm){
        case constants/* formTypes.EMAIL */.o_.EMAIL:
            return renderFormComponent(/*#__PURE__*/ (0,jsx_runtime.jsx)(register_EmailRegister, {
                onRegister: handleVerifyEmailRegistration
            }), false);
        case constants/* formTypes.NOTIFY_VERIFICATION_EMAIL */.o_.NOTIFY_VERIFICATION_EMAIL:
            return renderFormComponent(/*#__PURE__*/ (0,jsx_runtime.jsx)(register_NotifyVerification, {
                type: "email",
                recipient: email,
                onContinue: handleContinueVerifyEmail
            }));
        case constants/* formTypes.VERIFY_EMAIL */.o_.VERIFY_EMAIL:
            return renderFormComponent(/*#__PURE__*/ (0,jsx_runtime.jsx)(register_VerifyEmail, {
                onVerify: handleVerifyEmail,
                onChangeEmail: handleChangeEmail,
                onResend: handleResendCodeEmail,
                email: email
            }));
        case constants/* formTypes.PHONE */.o_.PHONE:
            return renderFormComponent(/*#__PURE__*/ (0,jsx_runtime.jsx)(register_PhoneRegister, {
                onRegister: handleRegisterUser
            }));
        case constants/* formTypes.SEND_OTP_METHOD */.o_.SEND_OTP_METHOD:
            return renderFormComponent(/*#__PURE__*/ (0,jsx_runtime.jsx)(register_SendOTPMethod, {
                phone: phoneNumber,
                onSubmit: handleSendOTPSubmit
            }));
        case constants/* formTypes.NOTIFY_VERIFICATION_PHONE */.o_.NOTIFY_VERIFICATION_PHONE:
            return renderFormComponent(/*#__PURE__*/ (0,jsx_runtime.jsx)(register_NotifyVerification, {
                type: "phone",
                recipient: phoneNumber,
                onContinue: handleContinueVerifyPhone
            }));
        case constants/* formTypes.PHONE_ERROR */.o_.PHONE_ERROR:
            return renderFormComponent(/*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneError, {
                onBackLogin: handleBackToLogin,
                onBackChangePhone: handleChangePhone
            }), false);
        case constants/* formTypes.OTP_LIMIT */.o_.OTP_LIMIT:
            return renderFormComponent(/*#__PURE__*/ (0,jsx_runtime.jsx)(register_OtpLimit, {
                onBackClick: handleChangePhone
            }), false);
        case constants/* formTypes.VERIFY_PHONE */.o_.VERIFY_PHONE:
            return renderFormComponent(/*#__PURE__*/ (0,jsx_runtime.jsx)(register_VerifyPhone, {
                onVerify: handleVerifyPhone,
                onChangePhone: handleChangePhone,
                onResend: handleResendCodePhone,
                phoneNumber: phoneNumber,
                autoRedirect: type !== constants/* registerTypes.GOOGLE */.E8.GOOGLE && type !== constants/* registerTypes.FACEBOOK */.E8.FACEBOOK
            }));
        case constants/* formTypes.SUCCESS */.o_.SUCCESS:
            return renderFormComponent(/*#__PURE__*/ (0,jsx_runtime.jsx)(register_SuccessfulRegistration, {}), false);
        case constants/* formTypes.SELECTION */.o_.SELECTION:
        default:
            return renderFormComponent(/*#__PURE__*/ (0,jsx_runtime.jsx)(register_Selection, {
                handleOnMount: handleResetState,
                handleNavigate: handleChangeEmail
            }), false);
    }
}
/* harmony default export */ var register = (Register);


/***/ }),

/***/ 27253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28896);




function Divider(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, label = param.label;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .DividerContainer */ .kP, {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .Center */ .M5, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                align: "center",
                color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].midgray */ .Z.midgray,
                children: label
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Divider);


/***/ }),

/***/ 37662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var ChatSvg = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M2.5 18.625C2.33424 18.625 2.17527 18.5592 2.05806 18.4419C1.94085 18.3247 1.875 18.1658 1.875 18V4.66667C1.87544 4.05901 2.11702 3.47638 2.5467 3.0467C2.97637 2.61703 3.55901 2.37544 4.16667 2.375H15.8333C16.441 2.37544 17.0236 2.61703 17.4533 3.0467C17.883 3.47638 18.1246 4.05901 18.125 4.66667V13C18.1246 13.6077 17.883 14.1903 17.4533 14.62C17.0236 15.0496 16.441 15.2912 15.8333 15.2917H6.0925L2.94167 18.4417C2.88379 18.4999 2.81497 18.546 2.73917 18.5775C2.66336 18.609 2.58208 18.6251 2.5 18.625ZM4.16667 3.625C3.89053 3.62544 3.62584 3.73533 3.43058 3.93058C3.23533 4.12584 3.12544 4.39053 3.125 4.66667V16.4908L5.39167 14.225C5.44957 14.1668 5.5184 14.1207 5.5942 14.0892C5.66999 14.0578 5.75126 14.0416 5.83333 14.0417H15.8333C16.1095 14.0412 16.3742 13.9313 16.5694 13.7361C16.7647 13.5408 16.8746 13.2761 16.875 13V4.66667C16.8746 4.39053 16.7647 4.12584 16.5694 3.93058C16.3742 3.73533 16.1095 3.62544 15.8333 3.625H4.16667Z",
            fill: "currentColor"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ChatSvg);


/***/ }),

/***/ 68749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var WhatsAppSvg = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M3.54912 14.328C2.6173 12.7572 2.29097 10.9002 2.6314 9.10583C2.97184 7.31142 3.95563 5.70301 5.39803 4.58261C6.84044 3.46222 8.64224 2.90692 10.4651 3.02099C12.2879 3.13506 14.0065 3.91065 15.2979 5.20212C16.5894 6.49359 17.365 8.2121 17.4791 10.035C17.5932 11.8578 17.0379 13.6596 15.9175 15.102C14.7971 16.5444 13.1887 17.5282 11.3943 17.8687C9.59988 18.2091 7.74291 17.8828 6.17207 16.951L6.17209 16.9509L3.58174 17.691C3.47456 17.7216 3.36115 17.723 3.25326 17.6951C3.14536 17.6671 3.0469 17.6108 2.96809 17.532C2.88927 17.4532 2.83297 17.3547 2.80501 17.2468C2.77705 17.1389 2.77846 17.0255 2.80908 16.9184L3.54918 14.328L3.54912 14.328Z",
                stroke: "currentColor",
                strokeWidth: "0.9375",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M11.8839 14.875C11.0616 14.8762 10.2472 14.7151 9.48733 14.4009C8.72744 14.0868 8.03701 13.6258 7.45558 13.0444C6.87416 12.463 6.41318 11.7726 6.09906 11.0127C5.78493 10.2528 5.62384 9.43837 5.62501 8.61612C5.62687 8.03735 5.85821 7.48294 6.2683 7.07452C6.67839 6.6661 7.23373 6.43701 7.8125 6.4375C7.90743 6.4375 8.00068 6.4626 8.08278 6.51025C8.16489 6.55789 8.23294 6.6264 8.28004 6.70883L9.1934 8.30721C9.24849 8.4036 9.2769 8.51293 9.27572 8.62394C9.27454 8.73496 9.2438 8.84366 9.18668 8.93886L8.45316 10.1614C8.83054 10.9989 9.50113 11.6695 10.3386 12.0468L11.5611 11.3133C11.6563 11.2562 11.765 11.2255 11.8761 11.2243C11.9871 11.2231 12.0964 11.2515 12.1928 11.3066L13.7912 12.22C13.8736 12.2671 13.9421 12.3351 13.9898 12.4172C14.0374 12.4993 14.0625 12.5926 14.0625 12.6875C14.0608 13.2656 13.8311 13.8197 13.4231 14.2293C13.0151 14.639 12.462 14.871 11.8839 14.875Z",
                stroke: "currentColor",
                strokeWidth: "0.9375",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WhatsAppSvg);


/***/ }),

/***/ 73580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59148);



var initialState = {
    errorCode: null,
    errorMessage: "",
    errorType: ""
};
var mainLayoutStore = (0,zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setErrorCode: function(code) {
            var message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
            set({
                errorCode: code,
                errorMessage: message,
                errorType: type
            });
        },
        resetErrorCode: function() {
            set(initialState);
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (mainLayoutStore);


/***/ }),

/***/ 50226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_OtpMethodList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/es/checkbox/index.js + 2 modules
var es_checkbox = __webpack_require__(32808);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/SelectCardMethod/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  background: none;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  cursor: pointer;\n\n  border: ",
        ";\n  border-radius: 4px;\n  padding: 16px;\n\n  transition: 0.15s ease-out border;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 20px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .ant-checkbox-inner,\n  & .ant-checkbox-checked::after {\n    border-radius: 8px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var ButtonContainer = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-feb18f86-0"
})(_templateObject(), function(param) {
    var isActive = param.isActive;
    return isActive ? "1px solid #00ab6b" : "1px solid #ededed";
});
var BoxRow = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).withConfig({
    componentId: "sc-feb18f86-1"
})(_templateObject1());
var IconCol = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).withConfig({
    componentId: "sc-feb18f86-2"
})(_templateObject2());
var MethodCheckbox = (0,styled_components_browser_esm/* default */.ZP)(es_checkbox/* default */.Z).withConfig({
    componentId: "sc-feb18f86-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/global/SelectCardMethod/index.tsx






var SelectCardMethod = function(_param) /*#__PURE__*/ {
    var title = _param.title, description = _param.description, icon = _param.icon, _onClick = _param.onClick, onClick = _onClick === void 0 ? function() {} : _onClick, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "description",
        "icon",
        "onClick"
    ]);
    return (0,jsx_runtime.jsx)(ButtonContainer, {
        type: "button",
        onClick: function() {
            return onClick(props.value);
        },
        isActive: props.checked,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxRow, {
            align: "middle",
            justify: "space-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                        align: "middle",
                        gutter: [
                            16,
                            0
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCol, {
                                children: icon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        size: "14px",
                                        height: "16px",
                                        color: "#333333",
                                        weight: props.checked ? "700" : "400",
                                        // @ts-expect-error
                                        mb: "2px",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        size: "12px",
                                        height: "16px",
                                        color: "#858585",
                                        children: description
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MethodCheckbox, (0,_object_spread/* default */.Z)({}, props))
                })
            ]
        })
    });
};
/* harmony default export */ var global_SelectCardMethod = (SelectCardMethod);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/typings/auth.ts
var auth = __webpack_require__(97718);
;// CONCATENATED MODULE: ./src/global/OtpMethodList/index.tsx






var OtpMethodList = function(param) {
    var _defaultMethod = param.defaultMethod, defaultMethod = _defaultMethod === void 0 ? auth/* OtpChannel.WhatsApp */.z.WhatsApp : _defaultMethod, data = param.data, _onSelect = param.onSelect, onSelect = _onSelect === void 0 ? function() {} : _onSelect;
    var ref = (0,react.useState)(defaultMethod), selectedMethod = ref[0], setSelectedMethod = ref[1];
    var handleMethodClick = function(value) {
        setSelectedMethod(value);
        onSelect(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
        gutter: [
            0,
            12
        ],
        children: data.map(function(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                span: 24,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_SelectCardMethod, (0,_object_spread/* default */.Z)({
                    onClick: handleMethodClick,
                    checked: selectedMethod === props.value
                }, props))
            }, props.value);
        })
    });
};
/* harmony default export */ var global_OtpMethodList = (OtpMethodList);


/***/ }),

/***/ 31151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



function useCountdown(param) {
    var onResend = param.onResend, _time = param.time, time = _time === void 0 ? 60 : _time;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(time), seconds = ref[0], setSeconds = ref[1];
    var startTimer = function() {
        setSeconds(time);
    };
    var formatNumber = function(number) {
        return number.toLocaleString("en-US", {
            minimumIntegerDigits: 2,
            useGrouping: false
        });
    };
    var onEnd = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return onResend();
                    case 2:
                        startTimer();
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onEnd() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var interval = setInterval(function() {
            if (seconds > 0) {
                setSeconds(seconds - 1);
                return;
            }
            clearInterval(interval);
        }, 1000);
        return function() {
            clearInterval(interval);
        };
    }, [
        seconds
    ]);
    var formatterSeconds = formatNumber(seconds % 60);
    var formattedMinutes = formatNumber(Math.floor(seconds / 60));
    var isFinished = seconds === 0;
    return {
        minutes: formattedMinutes,
        seconds: formatterSeconds,
        isFinished: isFinished,
        onEnd: onEnd
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useCountdown);


/***/ }),

/***/ 15077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Form value with state wrapper
 * @param {Object=} props
 * @param {*=} props.initialState
 * @returns {[*, function]}
 */ function useForm(param) {
    var _initialState = param.initialState, initialState = _initialState === void 0 ? "" : _initialState;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialState), value = ref[0], setValue = ref[1];
    var handleChange = function(e) {
        setValue(e.target.value);
    };
    return [
        value,
        handleChange
    ];
}
/* harmony default export */ __webpack_exports__["Z"] = (useForm);


/***/ }),

/***/ 76260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59148);



var initialState = {
    errorCode: 0,
    errorMessage: "",
    errorType: ""
};
var tradingStore = (0,zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setErrorCode: function(code) {
            var message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
            set({
                errorCode: code,
                errorMessage: message,
                errorType: type
            });
        },
        resetErrorCode: function() {
            set(initialState);
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (tradingStore);


/***/ }),

/***/ 97718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ LoginType; },
/* harmony export */   "z": function() { return /* binding */ OtpChannel; }
/* harmony export */ });
var LoginType;
(function(LoginType) {
    LoginType["Social"] = "social";
    LoginType["Securities"] = "securities";
})(LoginType || (LoginType = {}));
var OtpChannel;
(function(OtpChannel) {
    OtpChannel["Unspecified"] = "CHANNEL_UNSPECIFIED";
    OtpChannel["Sms"] = "CHANNEL_SMS";
    OtpChannel["WhatsApp"] = "CHANNEL_WHATSAPP";
})(OtpChannel || (OtpChannel = {}));


/***/ }),

/***/ 23485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ formatCensorPhoneNumber; },
/* harmony export */   "u": function() { return /* binding */ formatPhoneNumber; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36305);

var formatPhoneNumber = function(phone) {
    try {
        if (!phone) return "";
        var splitLength = Math.ceil((phone.length - 5) / 4);
        var splitArray = [
            phone.substring(0, 2),
            phone.substring(2, 5), 
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Array(splitLength).fill(4).map(function(_, idx) {
            return phone.substring(5 + 4 * idx, 5 + 4 * (idx + 1));
        })));
        return "".concat(splitArray.join("-"));
    } catch (e) {
        return phone;
    }
};
var formatCensorPhoneNumber = function(phone) {
    if (!phone) return "";
    return "".concat(phone.substring(0, 2), " ").concat(phone.substring(2, 4), "******").concat(phone.substring(phone.length - 3, phone.length), "\n  ");
};


/***/ })

}]);